
import { onMounted, computed, reactive, ref, defineComponent } from 'vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import FlowRegister from '@/components/block/FlowRegister.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import Button from '@/components/elements/Button.vue'
import TextLink from '@/components/elements/TextLink.vue'

export default defineComponent({
  name: 'RegistThanks',

  components: {
    HeadingLv2,
    FlowRegister,
    GoalButtons,
    Button,
    TextLink
  },

  setup(props: any, context) {
    const appUrl = process.env.VUE_APP_URL

    onMounted(() => {
      context.emit('update-flow', 5)
    })

    return { appUrl }
  }
})
